var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimplifiedWorkRelationPaycheckLineTemplateForm',{ref:"formRef",attrs:{"work-relation-id":_vm.$route.params.id,"dirty":_vm.dirtyForm},on:{"update:dirty":function($event){_vm.dirtyForm=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }